export const DOMAIN =
  'https://bnlwe-es01-d-57280-unilevercom-webapp-12.azurewebsites.net';
export const vaultDomain = 'https://sb-unilever-claims.veevavault.com';

export const environment = {
  production: false,
  apiUrl: 'https://claims-sparci-dev.unilever.com',
  socketUrl:
    'https://bnlwe-es02-d-931435-unilevercom-webapp-01.azurewebsites.net',
  // apiUrl: 'https://claims-sparci-qa.unilever.com',
  msalConfig: {
    auth: {
      clientId: 'a0e713ec-5846-4e31-9a4c-d587aec2323a',
      // clientId: '60922018-9804-4991-b274-eb5efecc8da6',
      authority:
        'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
      // redirectUri: 'http://localhost:4200',
      redirectUri: 'https://claims-sparci-dev.unilever.com/',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/.default',
  },
};
